module.exports = __webpack_public_path__ + "img/banner-sm-03.503e25ba.jpg";